const t = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M13.1 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-1.602 2L9 20.5h1.976l2.524-12z"/></svg>';
export {
  t as w
};
